<template>
	<div>
		<!-- <qrcode-vue :value="value" :size="size" level="H"></qrcode-vue> -->
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">UPI Payment</v-toolbar-title>
		    <v-spacer></v-spacer>

		    <!-- <v-btn icon @click="fn_htmlToImage">
		      <v-icon class="redcolor">save</v-icon>
		    </v-btn> -->

		    <v-btn icon @click="fn_getToken">
		      <v-icon class="redcolor">delete</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_editUpiId">
		      <v-icon>edit</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="hasToolbar">
			<v-card flat center-align id="upi-card">
				<v-card-text>
                    <p class="mb-1 font20"><b>{{$root.CurrentBusiness.UPIName}}</b></p>
                    <p class="mb-0"><b>UPI ID:</b> {{$root.CurrentBusiness.UpiID}}</p>
					<img :src="qrCode" style="width:200px"/>
					<p font16>Scan the QR code using any UPI app</p>
					<p class="mb-4 greencolor"><v-icon font20 class="greencolor">verified_user</v-icon> 100% Secure</p>
					<p font20 class="pt-2 pb-2" style="border-top:1px #ddd solid;border-bottom:1px #ddd solid">{{$root.CurrentBusiness.BusinessName}}</p>
					<!-- <p font20 class="pt-2 pb-2" style="border-top:1px #ddd solid;border-bottom:1px #ddd solid">Meera Garments Pvt. Ltd</p> -->

					<div>
						<div class="branding mt-4">
							<a href="https://bizopsapp.com/" target="_blank">
								<div class="font11">Powered By</div>
								<div class="title primary-color">
									<img class="brand_logo" src="../../../assets/Final_BizOpsLogo.svg" alt="bizops_logo">BizOps App
								</div>
							</a>
						</div>
					</div>
				</v-card-text>
			</v-card>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" style="border-radius:0;" @click="fn_htmlToImage">Share Payment Link</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
	// import QrcodeVue from 'qrcode.vue'

	import QRCode from 'qrcode'

	// import * as htmlToImage from 'html-to-image';
	// import { toPng } from 'html-to-image';
    import domtoimage from 'dom-to-image';

	export default{
		data(){
			return{
				qrCode:''
			}
		},
		// components: {
	 //      'qrcode-vue':QrcodeVue
	 //    },
		methods:{

			fn_htmlToImage: function(){
		        var node = document.getElementById('upi-card');

                let self = this;
                domtoimage.toPng(node).then(function (dataUrl) {
                    self.fn_shareQrCode(dataUrl);
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                });

		        // let self = this;
		        // htmlToImage.toPng(node, {pixelRatio:1})
		        //   .then(function (dataUrl) {
		        //     console.log(dataUrl);
		        //     self.fn_shareQrCode(dataUrl);
		        //   })
		        //   .catch(function (error) {
		        //     console.error('oops, something went wrong', error);
		        //   });
		    },

			fn_editUpiId: function(){
				this.$router.push({"path":"/settings/payment/upi/new", "query":{"edit":1}});
			},

			fn_generateQrCode: function(){
				let self = this;
				let url = "upi://pay?pa="+this.$root.CurrentBusiness.UpiID+"&pn="+this.$root.CurrentBusiness.UPIName;
				// let url = "https://google.com"
				QRCode.toDataURL(url)
				  .then(url => {
				    console.log(url);
				    self.qrCode = url;
				  })
				  .catch(err => {
				    console.error(err)
				})
			},

			fn_getToken: function(){
				let self = this;
				this.showLoading("Please wait...");
				this.$root.fn_getAuthToken(function(token){
            		self.fn_removeUpiDetails(token);
				});
			},

			fn_removeUpiDetails: function(token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                let self = this;

                let postObj = {};
                postObj.businessId = this.$root.CurrentBusiness.BusinessID;
                postObj.token = token

                console.log(JSON.stringify(postObj));

                this.getServerData('RemoveUpiId', postObj, {
                    onSuccess: function(response){
                       console.log(response);
                       self.$root.CurrentBusiness.UpiID = null;
                       self.$root.CurrentBusiness.UPIName = null;
                       self.showToast("Upi details removed");
                       self.hideLoading();
                       self.fn_goBack();
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })
            },

            fn_shareQrCode: function(dataUrl){
            	let shareObj = {};
	            shareObj.type = "image"
	            shareObj.shareType = "share"
	            shareObj.primaryMobileNumber = null;
	            shareObj.email = null;
	            shareObj.subject = null;
	            shareObj.textMessage = this.$tShare('share.qrCodeMessage');
	            // shareObj.base64String = this.dataUrl.substring(this.dataUrl.indexOf(',') + 1);
	            shareObj.base64String = dataUrl.substring(dataUrl.indexOf(',') + 1);
	            this.$root.fn_share(shareObj);
            },

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){
			this.fn_generateQrCode();
			window.js_globals.fn_onBackPress = this.fn_goBack;
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/settings/payment/display_upi.vue